import $ from "jquery";
/*import WPAPI from 'wpapi';*/

let config = {
    colorboxEl: $('.blocks-gallery-item').not('.custom-link'),
    apiRoot: 'http://restapi.lara/wp-json/'
};

/*config.wp = new WPAPI( { endpoint: config.apiRoot } );*/

export default config;